import React from 'react';
import { useAuth } from '../context/AuthContext';
import NotificationBell from './NotificationBell';
import MessengerLink from './MessengerLink';

const ROLE_LABEL = {
  reception: 'پذیرش',
  imaging: 'تصویربرداری',
  editor: 'ادیتور',
  technical: 'مسئول فنی',
  admin: 'مدیر سامانه',
};

export default function Layout({ title, subtitle, tabs, activeTab, onTabChange, actions, children }) {
  const { user, logout } = useAuth();

  return (
    <div className="shell">
      <header className="topbar">
        <div className="topbar__inner">
          <div className="brand">
            <span className="brand__mark" aria-hidden="true" />
            <span className="brand__text">
              <strong>FlowTrack</strong>
              <small>گردش کار گزارش‌نویسی</small>
            </span>
          </div>

          <div className="topbar__right">
            <NotificationBell />
            <MessengerLink />
            <div className="who">
              <span className="who__name">{user?.display_name || user?.username}</span>
              <span className="who__role">{ROLE_LABEL[user?.role] || user?.role}</span>
            </div>
            <button type="button" className="btn btn--ghost btn--sm" onClick={logout}>
              خروج
            </button>
          </div>
        </div>
      </header>

      <main className="page">
        <div className="page__head">
          <div>
            <h1>{title}</h1>
            {subtitle && <p className="page__subtitle">{subtitle}</p>}
          </div>
          {actions && <div className="page__actions">{actions}</div>}
        </div>

        {tabs && (
          <nav className="tabs" role="tablist">
            {tabs.map((tab) => (
              <button
                key={tab.id}
                type="button"
                role="tab"
                aria-selected={activeTab === tab.id}
                className={`tab ${activeTab === tab.id ? 'is-active' : ''}`}
                onClick={() => onTabChange(tab.id)}
              >
                {tab.label}
                {tab.count !== undefined && <span className="tab__count num">{tab.count}</span>}
              </button>
            ))}
          </nav>
        )}

        {children}
      </main>
    </div>
  );
}

export function StatTile({ label, value, hint, tone = 'default' }) {
  return (
    <div className={`tile tile--${tone}`}>
      <span className="tile__label">{label}</span>
      <span className="tile__value num">{value}</span>
      {hint && <span className="tile__hint">{hint}</span>}
    </div>
  );
}

export function EmptyState({ icon = '🗂️', title, hint }) {
  return (
    <div className="empty">
      <span className="empty__icon" aria-hidden="true">{icon}</span>
      <p className="empty__title">{title}</p>
      {hint && <p className="empty__hint">{hint}</p>}
    </div>
  );
}

/**
 * پیمایش صفحه‌ها. وقتی فقط یک صفحه هست چیزی نشان نمی‌دهد.
 *
 * بازه‌ی نمایشی («۵۱ تا ۱۰۰ از ۲۳۴») لازم است: بدون آن کاربر نمی‌فهمد فهرست
 * ادامه دارد و صفحه‌ی اول را همه‌ی پرونده‌ها می‌پندارد.
 */
export function Pager({ page, pageCount, pageSize, count, onChange }) {
  if (pageCount <= 1) return null;

  const from = (page - 1) * pageSize + 1;
  const to = Math.min(page * pageSize, count);
  const fa = (n) => new Intl.NumberFormat('fa-IR').format(n);

  return (
    <nav className="pager" aria-label="پیمایش صفحه‌ها">
      <button
        type="button"
        className="btn btn--ghost btn--sm"
        onClick={() => onChange(page - 1)}
        disabled={page <= 1}
      >
        قبلی
      </button>

      <span className="pager__info num">
        {fa(from)}–{fa(to)} از {fa(count)}
      </span>

      <button
        type="button"
        className="btn btn--ghost btn--sm"
        onClick={() => onChange(page + 1)}
        disabled={page >= pageCount}
      >
        بعدی
      </button>
    </nav>
  );
}

export function Spinner({ label = 'در حال بارگذاری…' }) {
  return (
    <div className="spinner" role="status">
      <span className="spinner__dot" />
      <span>{label}</span>
    </div>
  );
}
